/** 工作流任务批次号：YYYYMMDD + 创建时刻时间戳后 5 位 */
export function generateWorkflowTaskBatchNo(date = new Date()) {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) {
    return generateWorkflowTaskBatchNo(new Date());
  }
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const tsSuffix = String(d.getTime()).slice(-5);
  return `${y}${m}${day}${tsSuffix}`;
}

/** 展示/筛选用批次号：优先 task.batchNo，旧任务按 createdAt 回推 */
export function resolveWorkflowTaskBatchNo(task) {
  if (!task) return '';
  const stored = String(task.batchNo || '').trim();
  if (stored) return stored;
  if (task.createdAt) {
    const derived = generateWorkflowTaskBatchNo(new Date(task.createdAt));
    if (derived) return derived;
  }
  return String(task.id || '').trim();
}
